import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=5f8f0fd5&scoped=true&functional=true"
import script from "./scope.vue?vue&type=script&lang=js"
export * from "./scope.vue?vue&type=script&lang=js"
import style0 from "./scope.vue?vue&type=style&index=0&id=5f8f0fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5f8f0fd5",
  null
  
)

export default component.exports